// Campo opcional: vazio é válido; quando preenchido, exige exatamente 4 dígitos.
export function validateLastFourDigits(value: string): boolean {
  return value === '' || /^\d{4}$/.test(value)
}
